export default "__VITE_ASSET__DwNdhBTi__"